// MIT License - Copyright (c) 2026 Doug McNall

import React, { useState } from 'react';
import { ProgressionSystem } from '../utils/game/ProgressionSystem';
import './RankDisplay.css';

/**
 * Rank Display Component
 * Shows current rank and progress to next rank
 */
const RankDisplay = ({ stats, onClick }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const currentRank = ProgressionSystem.getRank(stats);
  const nextRank = ProgressionSystem.getNextRank(currentRank);
  const progress = ProgressionSystem.getProgressToNextRank(stats, currentRank);
  const requirements = ProgressionSystem.getRequirements(stats, currentRank);
  
  return (
    <div 
      className="rank-display"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={onClick}
    >
      <div className="rank-badge">
        <span className="rank-icon">⭐</span>
        <span className="rank-name">{currentRank.rank}</span>
      </div>
      
      {nextRank && (
        <div className="rank-progress-bar">
          <div 
            className="rank-progress-fill"
            style={{ width: `${progress}%` }}
          />
          <span className="rank-progress-text">{progress}%</span>
        </div>
      )}
      
      {showTooltip && (
        <div className="rank-tooltip">
          <div className="tooltip-header">
            <strong>{currentRank.rank}</strong>
            <span className="tooltip-level">Level {currentRank.level}</span>
          </div>
          <div className="tooltip-description">{currentRank.description}</div>
          
          {nextRank ? (
            <>
              <div className="tooltip-divider" />
              <div className="tooltip-next-rank">
                Next: <strong>{nextRank.rank}</strong>
              </div>
              <div className="tooltip-requirements">
                {requirements.requirements.map((req, idx) => (
                  <div key={idx} className={`requirement ${req.complete ? 'complete' : ''}`}>
                    <span className="req-icon">{req.complete ? '✓' : '○'}</span>
                    <span className="req-name">{req.name}:</span>
                    <span className="req-progress">
                      {req.current.toLocaleString()} / {req.required.toLocaleString()}
                    </span>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="tooltip-divider" />
              <div className="tooltip-max-rank">🏆 Maximum Rank Achieved!</div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default RankDisplay;
